export default "__VITE_ASSET__BU340ulB__"